import { Decimal } from "decimal.js";
import { z } from "zod";

// biome-ignore lint/suspicious/noExplicitAny:
export type ZodSchema<T> = z.ZodType<T, any, any>;

export const decimalSchema = z.coerce.string().transform((val) => new Decimal(val));
export { Decimal };
